export class GoodToKnowRoutingRouteNames {
    public static readonly Article = 'article';
    public static readonly Overview = 'overview';
}
